<script lang="ts" setup>
import { computed } from 'vue'
import type { RecentReport } from './RecentReport.types'
import { formatDate } from '@/utils/date'
import { useRouteLink } from '@/composables/useRouteLink'
import { ROUTE_PATHS } from '@/utils/route'

const props = defineProps<RecentReport>()
const { routeLink } = useRouteLink()
const formattedDate = computed(() => formatDate(props.date, 'DD/MM/YYYY'))
</script>

<template>
  <article class="recent-report">
    <p class="recent-report__date">
      {{ formattedDate }}
    </p>

    <h3 class="recent-report__title">
      {{ title }}
    </h3>

    <NuxtLink
      :to="routeLink(ROUTE_PATHS.FOR_INVESTORS_ARTICLE_URL, { url: url })"
      class="recent-report__link"
    >
      {{ $t('common.more') }}

      <img
        class="recent-report__svg"
        src="/icons/icn_arrow_right.svg"
        aria-hidden="true"
      >
    </NuxtLink>
  </article>
</template>

<style lang="scss" scoped>
.recent-report {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  height: 100%;
  padding: 3.2rem;
  background-color: $gray-100;
  border: 1px solid $base-50;
  border-radius: 1.2rem;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: $white;
  }

  &__date {
    @include body-3;
    color: $text-300;
  }

  &__title {
    @include h10;
    flex: 1 0 auto;
    color: $text-400;
  }

  &__link {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-top: auto;
    color: $text-400;
    cursor: pointer;
    @include body-3-medium;
    transition: color 0.2s ease;

    &:hover {
      color: $text-300;
    }
  }
}
</style>
